import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TabItem, TabSection } from 'src/app/components/form-group/form-group.types';
import { TabItemComponent } from 'src/app/components/form-group/tab-item/tab-item.component';

@Component({
    selector: 'app-tab-section',
    imports: [
        TabItemComponent
    ],
    templateUrl: './tab-section.component.html',
    styleUrl: './tab-section.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabSectionComponent {
  @Input({ required: true }) section!: TabSection;
  @Input({ required: true }) element!: Record<string, string>;

  trackByItem(item: TabItem) {
    return item.key;
  }
}
